import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';

import { IQuoteListApiResponse } from '@modules/private/quote/data/interfaces/iquote.interface';
import { ApiClass } from '@data/class/api-class';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiQuotesService extends ApiClass {
  id!: string

  constructor() {
    super()
    this.path = 'quotations'
  }

  /**
   * Obtener todas las cotizaciones calculadas para un cliente específico
   * IMPORTANTE: Adaptado para nueva estructura con termData y amortizationPeriods
   */
  getAll(page = 1, limit = 10, filters = {}) {
    const response: IQuoteListApiResponse = {
      error: true,
      msg: 'Error de conexión',
      data: {
        data: [],
        total: 0
      },
      status: 500,
      page: 1,
      itemsByPage: 10,
      totalItems: 0
    }

    // Filtrar solo cotizaciones del cliente específico
    filters = {
      client: { value: this.id, matchMode: 'equals' }
    }

    return this.http.post<IQuoteListApiResponse>(environment.apiUrl + this.path, { page, limit, filters }).pipe(
      map((r) => r as IQuoteListApiResponse),
      catchError((e) => of(response))
    )
  }
}
